import bird from './assets/static/bird.png';
import wolf from './assets/static/wolf.png';
import { BirdImage, Container, WolfImage } from './styles';

const DefaultOnboardingAccent = () => (
    <Container>
        <BirdImage src={bird} alt="Onboarding visual bird" />
        <WolfImage src={wolf} alt="Onboarding visual wolf" />
    </Container>
);

export default DefaultOnboardingAccent;
